import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import CLOSE from "../../../../assets/images/icons/close.svg";
import Input from "../../../inputs/inputs";
import Button from "../../../buttons/buttons";
import { Beat } from "../../../../plugins/spinners.plugin";
import { searchServiceAreas } from "../../../../redux/serviceAreas/serviceAreasActions";
import serviceAreaType from "../../../../redux/serviceAreas/serviceAreasTypes";
import {
  attachShipper,
  showShipper,
} from "../../../../redux/shippers/shippersActions";

export default React.forwardRef(function AttachServiceArea(
  {
    visibility = false,
    disableClose = false,
    disableOpen = false,
    onOpen = () => {},
    onClose = () => {},
    shipper_id,
  },
  ref
) {
  // Ref handler
  React.useImperativeHandle(ref, () => ({
    open: () => openModal(),
    close: () => closeModal(),
  }));

  const dispatch = useDispatch();
  let [isOpen, setIsOpen] = React.useState(visibility);
  const [submitted, setSubmitted] = useState(false);
  const [serviceArea, setServiceArea] = React.useState("");
  const [input, setInput] = useState({
    service_area_id: "",
    charge: "",
  });

  const { updating, search } = useSelector((state) => state.serviceArea);

  function closeModal() {
    !disableClose && setIsOpen(false);
    !disableClose && onClose();
  }

  function openModal() {
    !disableOpen && setIsOpen(true);
    !disableOpen && onOpen();
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setInput({ ...input, [name]: value });
  };

  const handleSearch = (event) => {
    event.preventDefault();
    const { value } = event.target;
    setServiceArea(value);
    if (value.length >= 3) {
      dispatch(
        searchServiceAreas({
          search: value,
        })
      );
    } else if (value.length <= 3) {
      dispatch({ type: serviceAreaType["SEARCH_SERVICE_AREAS"], payLoad: [] });
    }
  };

  function selectServiceArea(result) {
    setInput((input) => ({
      ...input,
      service_area_id: result.id ?? "",
    }));

    setServiceArea(result.area);
    var mydiv = document.getElementById(result.id);
    if (result.id) {
      mydiv.style.borderColor = "border-[#D14522]";
    }
    dispatch({ type: serviceAreaType["SEARCH_SERVICE_AREAS"], payLoad: [] });
  }

  const handleSubmit = async () => {
    setSubmitted(true);
    await dispatch(
      attachShipper({
        id: shipper_id,
        service_area_id: input.service_area_id,
        charge: input.charge,
      })
    );
    dispatch(showShipper(shipper_id));
    closeModal();
  };
  return (
    <React.Fragment>
      <Button.Primary
        type={"button"}
        title={"Attach Service Area"}
        onClick={openModal}
      />

      <Transition appear show={visibility || isOpen} as={React.Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <div className="min-h-screen px-4">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay
                className="fixed inset-0"
                style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
              />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-center justify-center min-h-full p-4 sm:p-0">
                <Transition.Child
                  as={React.Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="relative w-[629px] bg-white dark:bg-[#121212] rounded-sm px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:my-10 sm:max-w-lg sm:w-full sm:p-8">
                    <div>
                      <div className="sm:block absolute top-4 right-5">
                        <button
                          type="button"
                          className="bg-[#ffeae5] rounded-md  p-1 sm:p-3  "
                          onClick={closeModal}
                        >
                          <span className="sr-only">Close</span>
                          <img src={CLOSE} alt="close" className=" w-3 h-3" />
                        </button>
                      </div>
                      <div className="sm:flex">
                        <div className="text-left sm:text-left sm:px-8">
                          <Dialog.Title
                            as="p"
                            className="text-md font-medium text-[#717485] dark:text-white"
                          >
                            Service Area Charge
                          </Dialog.Title>
                        </div>
                      </div>
                    </div>

                    <div className=" border-b-2 mt-4"></div>
                    <div className="mt-5 sm:mx-auto w-full p-4">
                      <form>
                        <div className="w-full">
                          <div>
                            <Input.Label
                              title={"Service area"}
                              htmlFor={"area"}
                              name={"area"}
                              value={serviceArea}
                              placeholder={"Search service area"}
                              onChange={handleSearch}
                            />
                            {submitted && !input.service_area_id && (
                              <div className="text-primary text-xs ">
                                Service area is required
                              </div>
                            )}

                            {search &&
                              Array.isArray(search) &&
                              search?.map((result, index) => (
                                <div
                                  className="p-3 border border-primary mb-2"
                                  id={result.id}
                                  key={index}
                                  onClick={() => selectServiceArea(result)}
                                >
                                  <div className=" grid-cols-3">
                                    <div className="col-span-1">
                                      <div>
                                        <h6 className="text-sm font-meduim">
                                          Area: {result.area} ({result.state})
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>

                          <div>
                            <Input.Number
                              title={"Charge"}
                              htmlFor={"charge"}
                              name={"charge"}
                              placeholder={"NGN 1000"}
                              defaultValue={input?.charge}
                              onChange={(e) => handleChange(e)}
                            />
                            {submitted && !input.charge && (
                              <div className="text-primary text-xs ">
                                Base charge is required
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="mt-8 mb-3 text-center flex justify-center gap-5">
                          <Button.Primary
                            type={"button"}
                            disabled={updating}
                            title={updating ? <Beat /> : "Attach Area"}
                            onClick={handleSubmit}
                          />
                        </div>
                      </form>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition>
    </React.Fragment>
  );
});
